import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderFormStatusMessage',
  props: {
  message: { type: String, required: true },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_ot_info = _resolveComponent("ot-info")!
  const _component_ot_transition_fade = _resolveComponent("ot-transition-fade")!

  return (_openBlock(), _createBlock(_component_ot_transition_fade, null, {
    default: _withCtx(() => [
      _createVNode(_component_ot_info, {
        class: "order-form-status-message",
        variant: "dark",
        message: __props.message,
        "is-warning": true
      }, null, 8, ["message"])
    ]),
    _: 1
  }))
}
}

})